import React from 'react';
import PropTypes from 'prop-types';
import { childNodes } from 'Helpers/PropTypes';

const FormElement = ({ children, ...props }) => {
  const { className } = props;
  return (
    <div
      {...props}
      className={`FormElement ${className}`.trim()}
      role="presentation"
    >
      {children}
    </div>
  );
};

FormElement.propTypes = {
  className: PropTypes.string,
  children: childNodes.isRequired,
};

FormElement.defaultProps = {
  className: '',
};

export default FormElement;
